/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free molecular weight (molar mass) calculator. Enter a chemical formula like C6H12O6 or CuSO4·5H2O to get the molar mass and per-element mass percentages.`)
};

const es_mw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de peso molecular (masa molar). Introduce una fórmula química como C6H12O6 o CuSO4·5H2O para obtener la masa molar y los porcentajes de masa por elemento.`)
};

const de_mw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Molekulargewichts-(Molmasse-)Rechner. Geben Sie eine chemische Formel wie C6H12O6 oder CuSO4·5H2O ein, um die molare Masse und die Massenanteile pro Element zu erhalten.`)
};

const nl_mw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis molecuulgewicht- (molaire massa) calculator. Vul een chemische formule in zoals C6H12O6 of CuSO4·5H2O om de molaire massa en massapercentages per element te krijgen.`)
};

const fr_mw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur gratuit de masse moléculaire (masse molaire). Entrez une formule chimique comme C6H12O6 ou CuSO4·5H2O pour obtenir la masse molaire et les pourcentages de masse par élément.`)
};

const it_mw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito di peso molecolare (massa molare). Inserisci una formula chimica come C6H12O6 o CuSO4·5H2O per ottenere la massa molare e le percentuali di massa per elemento.`)
};

const pt_br2_mw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de peso molecular (massa molar). Informe uma fórmula química como C6H12O6 ou CuSO4·5H2O para obter a massa molar e os percentuais de massa por elemento.`)
};

const pt_mw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de massa molecular (massa molar). Introduza uma fórmula química como C6H12O6 ou CuSO4·5H2O para obter a massa molar e as percentagens de massa por elemento.`)
};

const ja_mw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の分子量（モル質量）計算ツール。C6H12O6やCuSO4·5H2Oのような化学式を入力すると、モル質量と元素ごとの質量パーセントが得られます。`)
};

const zh_mw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费分子量（摩尔质量）计算器。输入化学式，如 C6H12O6 或 CuSO4·5H2O，即可获得摩尔质量和各元素质量百分比。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_meta_description", locale)
	if (locale === "en") return en_mw_meta_description(inputs)
	if (locale === "es") return es_mw_meta_description(inputs)
	if (locale === "de") return de_mw_meta_description(inputs)
	if (locale === "nl") return nl_mw_meta_description(inputs)
	if (locale === "fr") return fr_mw_meta_description(inputs)
	if (locale === "it") return it_mw_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_mw_meta_description(inputs)
	if (locale === "pt") return pt_mw_meta_description(inputs)
	if (locale === "ja") return ja_mw_meta_description(inputs)
	return zh_mw_meta_description(inputs)
};